export class StringUtil {

  public static concatIdentifiers(selectedItems: any[]): string {
    return this.concatIdentifiers2(selectedItems, ',');
  }

  public static concatIdentifiers2(selectedItems: any[], separator: string): string {
    return selectedItems.map(item => item.id).join(separator);
  }

  public static removeLastCharacter(value: string): string {
    return value.substring(0, value.length - 1);
  }

  /**
   * Retorna un random String segun el tamaño indicado.
   */
  public static randomString(length) {
    const randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for ( let i = 0; i < length; i++ ) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }

  /**
   * Remueve la cantidad de caracteres empezando desde la parte final.
   */
  public static removeCharacter(value: string, cant: number): string {
    return value.substring(0, value.length - cant);
  }

  public static cut(source: string, finalSize: number, defaultValue?: string) {
    if (source === undefined) {
      return defaultValue;
    }
    return source.length > 42 ? source.substr(0, finalSize).concat('...') : source;
  }

  public static addZeros(numero: number) {
    return ('00' + numero).slice(-2);
  }

  /**
   * Divide un cadena en función al tamaño enviado y retornando un array de las mismas
   * @param str string a dividir
   * @param size tamaño de las diviciones
   */
  public static splitBy(str: string, size: number): string[] {
    const length = str.length - size + 1;
    return Array.from({length}, (_, i) => str.slice(i, i + size));
  }
}
